/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 outfit7.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/outfit7.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				geometry={nodes.hair001.geometry}
				material={materials["hair_defaultMat4.001"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.hair001_1.geometry}
				material={materials["Dummy_SHD1.001"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				geometry={nodes.oufit8_1.geometry}
				material={materials["Plain Blue Flat.001"]}
				position={[0, -0.729, 0.308]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.011, 0.012, 0.011]}
			/>
			<mesh
				geometry={nodes.oufit8_2.geometry}
				material={materials["Satin Fabric.005"]}
				position={[0, -0.729, 0.308]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.011, 0.012, 0.011]}
			/>
			<mesh
				geometry={nodes.oufit8_6.geometry}
				material={materials["Clean silver(Shiny Metal).001"]}
				position={[0, -0.729, 0.308]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.011, 0.012, 0.011]}
			/>
			<mesh
				geometry={nodes.oufit8_7.geometry}
				material={materials["Gold Shiny Clean.001"]}
				position={[0, -0.729, 0.308]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.011, 0.012, 0.011]}
			/>
			<mesh
				geometry={nodes.Retopo_body002.geometry}
				material={materials["Fabric.001"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
			/>
			<mesh
				geometry={nodes.Retopo_shoes_r003.geometry}
				material={materials["Material.001"]}
				position={[0.005, 0.028, 0.291]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
		</group>
	);
}

useGLTF.preload("models/outfit7.glb");
